import { uniq as _uniq } from 'lodash';

import { getTaskMaterials } from './getTaskMaterials';

export const getTasksMaterials = ({
  fileImages,
  tasks,
  initialState,
}: {
  fileImages: any;
  tasks: any;
  initialState: any;
}) => {
  const tasksImages: any[] = [];

  tasksImages.push(
    ...getTaskMaterials({ fileImages, taskLayers: initialState.layers }),
  );

  for (let i = 0; i < tasks.length; i++) {
    const task = tasks[i];

    tasksImages.push(
      ...getTaskMaterials({ fileImages, taskLayers: task.layers }),
    );
  }

  return fileImages.filter((fileImage: any) =>
    _uniq(tasksImages).some(
      (taskImage: any) => taskImage.imageRef === fileImage.imageRef,
    ),
  );
};
